import { graphql, Link } from "gatsby";
import * as React from "react";

import Layout from "../../../../components/blankLayout";
import VideoCard from "../../../../components/cards/videoCard";
import Image from "../../../../components/image";
import Seo from "../../../../components/seo";
import { ThemeContext } from "../../../../context/ThemeContext";
import { getSourceImageUrlToCGI } from "../../../../utils/base";

const ProgramGallery = ({ data }) => {
  const { program } = data || {};
  const { acfProgramsMeta: programDetails } = program || {};
  const { programFeaturedVideoTestimonials, projectVideo } = programDetails;

  const programFeaturedVideo = projectVideo ? projectVideo : "";

  const programGalleryCollection = programDetails?.gallery ?? [];

  const programGalleryFeaturedImage =
    programGalleryCollection?.[0]?.sourceUrl ?? "";

  const filteredGallery = programGalleryCollection.slice(1);

  const galleryPageTitle = `Gallery | ${program?.title}`;

  return (
    <ThemeContext.Consumer>
      {(theme) => (
        <Layout
          pageTitle={galleryPageTitle}
          containerClass={
            "w-full mx-auto planet:gvi-dark-gray-bg bg-primary-bg"
          }
        >
          <Seo
            title={galleryPageTitle}
            meta={[{ name: "robots", content: "noindex" }]}
            site={theme.site}
            lang={{}}
          />
          <section className="summary-section flex items-center justify-center relative">
            <Link
              to={program?.uri}
              className="bg-transparent w-full h-full absolute"
            ></Link>
            <div className="container w-9/12 py-12 relative">
              <div className="mb-5">
                <Link to={program?.uri} className="general-link">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-6 w-6"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M10 19l-7-7m0 0l7-7m-7 7h18"
                    />
                  </svg>
                </Link>
              </div>

              {programFeaturedVideo?.length > 50 ? (
                <div
                  className="project-video featured-video bg-white text-white col-span-2 row-span-2 rounded-sm sm:h-96"
                  dangerouslySetInnerHTML={{ __html: programFeaturedVideo }}
                />
              ) : (
                <div className="featured-image bg-white text-white col-span-2 row-span-2 rounded-sm">
                  <Image
                    imageAlt={"Featured image"}
                    image={""}
                    imageClass="object-cover w-full h-full"
                    sourceUrl={programGalleryFeaturedImage}
                  />
                </div>
              )}

              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-3 mt-2 mb-1">
                {programFeaturedVideoTestimonials &&
                  programFeaturedVideoTestimonials?.length > 0 &&
                  programFeaturedVideoTestimonials.map((videoUrl, idx) => {
                    const useVideo = videoUrl.programFeaturedVideo;
                    return (
                      <div key={`feat-video-item-${idx}`} className="">
                        <VideoCard
                          key={idx}
                          featVideos={useVideo}
                          cardClass={`${idx === 0 ? "mr-1 sm:mr-0" : ""} ${
                            idx === 1 ? "ml-1 sm:ml-0" : ""
                          }  h-auto sm:h-full bg-cover bg-no-repeat bg-center`}
                        />
                      </div>
                    );
                  })}

                {filteredGallery &&
                  filteredGallery?.map((imageItem, index) => {
                    const {
                      imageAlt,
                      localFile: imageSrc,
                      sourceUrl
                    } = imageItem;
                    return (
                      <div className="w-full h-96" key={index}>
                        <Image
                          imageAlt={imageAlt ?? ""}
                          image={""}
                          imageClass="object-cover w-full h-full"
                          sourceUrl={getSourceImageUrlToCGI({
                            uri: imageSrc?.extension
                              ? imageSrc.publicURL
                              : sourceUrl
                          })}
                        />
                      </div>
                    );
                  })}
              </div>
            </div>
          </section>
        </Layout>
      )}
    </ThemeContext.Consumer>
  );
};

// export async function config() {
//   return ({ params }) => {
//     return {
//       defer: true
//     };
//   };
// }

export const Head = ({ data }) => {
  const galleryPageTitle = `Gallery | ${data?.program?.title}`;

  return (
    <Seo
      title={galleryPageTitle}
      meta={[{ name: "robots", content: "noindex" }]}
      lang={{}}
      description={""}
    />
  );
};

export const programGalleryQuery = graphql`
  query ($id: String!) {
    program: wpProgram(id: { eq: $id }) {
      title
      databaseId
      uri
      slug
      acfProgramsMeta {
        programIngo
        projectVideo
        programFeaturedVideoTestimonials {
          programFeaturedVideo
        }
        gallery: pgmGallery {
          ...programGalleryData
        }
      }
      featuredImage {
        node {
          ...programGalleryData
        }
      }
    }
  }
`;

export default ProgramGallery;
